/**
 * History Stack Configuration
 * Centralized settings for back navigation and history management
 */
const HistoryConfig = {
  // Session storage keys
  HISTORY_KEY: "infiniteScroll:historyStack",
  RESTORE_FLAG_KEY: "infiniteScroll:restoreFlag",
  BACK_TRIGGER_STATE: "infiniteScroll:backTrigger",

  // Stack settings
  MAX_STACK_SIZE: 20,

  // Timing
  SCROLL_SETTLE_DELAY: 150, // ms - debounce for scroll position updates
};

// Export for module usage
if (typeof module !== "undefined" && module.exports) {
  module.exports = HistoryConfig;
}
